import { AsyncPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { LombardFacade } from '@zero/lombard/domain';
import { IncludesPipe } from '@zero/shared/ui-pipes';

@Component({
  selector: 'lombard-faqs',
  templateUrl: './lombard-faqs.component.html',
  styleUrls: ['./lombard-faqs.component.scss'],
  imports: [TranslocoPipe, IncludesPipe, AsyncPipe],
})
export class LombardFaqsComponent {
  @Input() public fatPadding = true;

  public readonly facade = inject(LombardFacade);
  public unfolded = [];

  public toggleFaq = (index: number): void => {
    this.unfolded = this.unfolded.includes(index) ? this.unfolded.filter((i) => i !== index) : [...this.unfolded, index];
  };
}
